const COLORS = [
  'bg-primary-100 text-primary-700',
  'bg-purple-100 text-purple-700',
  'bg-green-100 text-green-700',
  'bg-yellow-100 text-yellow-700',
  'bg-pink-100 text-pink-700',
];

function colorForName(name: string) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return COLORS[h % COLORS.length];
}

export function Avatar({
  name,
  src,
  size = 'md',
}: {
  name: string;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}) {
  const sizes = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-14 w-14 text-lg',
    xl: 'h-20 w-20 text-2xl',
  };
  const initials = name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={`${sizes[size]} rounded-full object-cover object-[center_34%] ring-2 ring-white`}
      />
    );
  }
  return (
    <div
      className={`${sizes[size]} ${colorForName(name)} flex flex-shrink-0 items-center justify-center rounded-full font-bold ring-2 ring-white`}
    >
      {initials}
    </div>
  );
}

export function Portrait({ name, src }: { name: string; src?: string | null }) {
  const initials = name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  if (src) {
    return (
      <img src={src} alt="" className="aspect-square w-full object-cover object-[center_34%]" />
    );
  }

  return (
    <div className="text-primary-700 flex aspect-square w-full items-center justify-center bg-[#efe8dc] font-serif text-3xl">
      {initials || '?'}
    </div>
  );
}

export function SquarePhoto({
  name,
  src,
  className = 'h-40 w-40',
}: {
  name: string;
  src?: string | null;
  className?: string;
}) {
  const initials = name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-[#EFE8DC] ${className}`}
    >
      {src ? (
        <img src={src} alt="" className="h-full w-full object-cover object-[center_34%]" />
      ) : (
        <span className="text-primary-700 font-serif text-3xl">{initials || '?'}</span>
      )}
    </div>
  );
}
